import { render, staticRenderFns } from "./serviceProvideManageList.vue?vue&type=template&id=b81ed526&scoped=true"
import script from "./serviceProvideManageList.vue?vue&type=script&lang=js"
export * from "./serviceProvideManageList.vue?vue&type=script&lang=js"
import style0 from "./serviceProvideManageList.vue?vue&type=style&index=0&id=b81ed526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81ed526",
  null
  
)

export default component.exports